module.exports = __webpack_public_path__ + "static/media/icon-picture.b4ca117b.svg";